import { FC } from "react";
import { useDispatch, useSelector } from "react-redux";

import { selectSuperuserUser } from "../../../../store/selectors/superuser";
import { stopImpersonation } from "../../../../store/superuser/slice";
import { CloseIcon } from "../../../icons";
import Button from "../../../Button/Button";

import styles from "./Supermode.module.css";



const Supermode: FC = () => {
  const user = useSelector(selectSuperuserUser);
  const dispatch = useDispatch();

  const handleDisableSupermode = () => {
    dispatch(stopImpersonation());
  };

  return (
    <div className={styles["trial"]}>
      <div className={styles["trial__content"]}>
        <span className={styles["trial__label"]}>Superuser</span>
        <p className={styles["trial__description"]}>{user?.email}</p>
      </div>

      <Button
        className={styles["trial__button"]}
        typeStyle="round-outline"
        Icon={CloseIcon}
        onClick={handleDisableSupermode}
        aria-label="Exit superuser mode"
      />
    </div>
  );
};

export default Supermode;
